import { render, staticRenderFns } from "./IdentityLoginButton.vue?vue&type=template&id=08555182&scoped=true&"
import script from "./IdentityLoginButton.vue?vue&type=script&lang=js&"
export * from "./IdentityLoginButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08555182",
  null
  
)

export default component.exports